import gsap from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.donate' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 50%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( this ).addClass( 'js-animated' );
            },
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'donate', COMPONENT );
} )( app );
